import { axiosClient } from "../AxiosClient";

const LIST_PATH = "/v1/whatsapp-schema/solicitudes";

/** Mismo sort que la lista clásica; si el backend V4 falla, probar `startDate,desc`. */
export const WHATSAPP_SCHEMA_SOLICITUDES_SORT = "createdDate,desc";

/**
 * @param {string} searcher
 * @returns {string}
 */
export const buildWhatsappSchemaSolicitudesSearch = (searcher) => {
  if (searcher == null || String(searcher).trim() === "") return "";
  const q = String(searcher).trim();
  return (
    `commerceName:'*${q}*' OR nameClient:'*${q}*' OR documentNumber:'*${q}*' OR ` +
    `cellphoneCommerce:'*${q}*' OR cellphoneClient:'*${q}*' OR paso:'*${q}*'`
  );
};

/**
 * @param {{ page?: number; size?: number; sort?: string; search?: string }} params
 */
export const fetchWhatsappSchemaSolicitudes = (params) =>
  axiosClient.get(LIST_PATH, { params }).then((r) => r.data);

/**
 * Detalle: comercio, cliente, pasos, viabilidad, crédito.
 * GET `/v1/whatsapp-schema/solicitudes/{uuid}`
 *
 * @param {string} uuid — uuid de la solicitud (mismo que en el listado)
 * @returns {Promise<object>}
 */
export const fetchWhatsappSchemaSolicitudByUuid = (uuid) =>
  axiosClient.get(`${LIST_PATH}/${uuid}`).then((r) => r.data);
